export const tryExecute = (value, data, ...rest) => {
  if (typeof value === 'function') {
    value = value(data, ...rest);
  }

  return Object.assign({}, data, value);
};

export const isArrayEqual = (arr1, arr2) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  return !arr1.some((item, index) => item !== arr2[index]);
};

export const scrollIntoView = (id) => {
  setTimeout(() => {
    // 滚动到新创建的流位置
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  }, 200);
};

// 判断字符串是否包含中文
export function hasChinese(str) {
  return /[\u4E00-\u9FA5]+/g.test(str);
}
